module.exports = __webpack_public_path__ + "assets/avatar.ed219a48.svg";